/* libs/oyan-ui/src/lib/features/sites/components/threshold-form/threshold-form.component.scss */
:host {
  display: block;
}
.oyan-ui-threshold-form-dialog {
  min-width: 400px;
  max-width: 600px;
}
.oyan-ui-threshold-form-dialog .dialog-card-header {
  padding: 0;
  margin: 0;
}
.oyan-ui-threshold-form-dialog .dialog-card-header .dialog-toolbar {
  padding: 0 16px;
}
.oyan-ui-threshold-form-dialog .dialog-card-header .dialog-toolbar .dialog-card-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
}
.oyan-ui-threshold-form-dialog .dialog-card-header .dialog-toolbar .regular-round-button {
  margin-left: auto;
}
.oyan-ui-threshold-form-dialog .dialog-card-content {
  min-height: 100px;
}
.oyan-ui-threshold-form-dialog .dialog-card-actions {
  padding: 16px 24px;
  gap: 12px;
}
.threshold-form-container {
  padding: 16px;
}
.threshold-form-container .form-actions {
  margin-top: 16px;
}
/*# sourceMappingURL=threshold-form.component.css.map */
